import { SiteMeta } from '@src/types/SiteMeta';
import { CustomLink } from '@src/types/SiteMetaUI';
import { KEYCLOAK_URL } from '@utils';
import { UserState } from '@store/reducers/userData';
import storeConnector from '@store/storeConnector';
import { isAdmin, isSuperAdmin } from '@src/services/auth';
import { useNavigate } from 'react-router';
import FormattedAlias from '../Translations/FormattedAlias';

interface UserPanelLinksProps {
  showSettings: () => void;
  showSupport: () => void;
  siteMeta: SiteMeta;
  role: UserState['role'];
}

function UserPanelLinks({
  showSettings,
  showSupport,
  siteMeta,
  role,
}: UserPanelLinksProps) {
  const navigate = useNavigate();
  return (
    <div className='links'>
      {isAdmin(role) && (
        <div onClick={() => navigate('/admin/users', { replace: true })}>
          <FormattedAlias id={'Manage Users'} />
        </div>
      )}
      {isSuperAdmin(role) && (
        <div onClick={() => navigate('/admin/audit-logs', { replace: true })}>
          <FormattedAlias id={'Audit Logs'} />
        </div>
      )}

      <div onClick={() => showSettings()}>
        <FormattedAlias id={'Settings'} />
      </div>
      <div onClick={() => showSupport()}>
        <FormattedAlias id={'Support'} />
      </div>

      {isSuperAdmin(role) && (
        <>
          <div
            style={{ marginTop: '30px' }}
            onClick={() => {
              window.location.href = `${KEYCLOAK_URL}admin/fractal/console/#/fractal`;
            }}
          >
            <FormattedAlias id={'Keycloak'} />
          </div>
          <div
            onClick={() => {
              window.location.href = `${document.location.origin}:8086/`;
            }}
          >
            <FormattedAlias id={'InfluxDB'} />
          </div>
        </>
      )}
      {(siteMeta.ui.custom_links || []).map((customLink: CustomLink) => (
        <div
          key={`user-custom-link-${customLink.display_name}`}
          onClick={() => {
            window.location.href = customLink.url;
          }}
        >
          {customLink.display_name}
        </div>
      ))}
    </div>
  );
}

export default storeConnector(UserPanelLinks, {
  user: ['role', 'keycloak'],
  config: ['siteMeta'],
});
